import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AlertIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', fill: 'transparent', ...sx }} {...props}>
      <g clipPath="url(#clip0_706_3127)">
        <path
          d="M11.0002 7.33325V10.9999M11.0002 14.6666H11.0093M20.1668 10.9999C20.1668 16.0625 16.0628 20.1666 11.0002 20.1666C5.93755 20.1666 1.8335 16.0625 1.8335 10.9999C1.8335 5.93731 5.93755 1.83325 11.0002 1.83325C16.0628 1.83325 20.1668 5.93731 20.1668 10.9999Z"
          stroke={props.color === 'warning' ? '#FF5F57' : '#14191F'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_706_3127">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default AlertIcon;
